import axiosPublicClient from "../../../../axiosPublicClient"
import axiosClient from "../../../../axiosClient"

export default async (dataForUploadUrl, file, payloadToSaveApplicantProgress, pageType) => {

    let result

    if (dataForUploadUrl.key) {
        result = await axiosPublicClient.post(`/consent-upload-url`, dataForUploadUrl)
    }
    else if (dataForUploadUrl.referenceNumber) {
        result = await axiosClient.post(`/consent-upload-url`, dataForUploadUrl)
    }

    if (!result) {
        throw Error("No result from consent-upload-url")
    }

    const url = result.data.url

    const u = new URL(url)

    const contentUrl = `${u.origin}${u.pathname}`

    await axiosPublicClient.put(url, file, {
        headers: {
            'Content-Type': file.type,
        },
        transformRequest: (data, headers) => data, // ensure raw file goes as-is
    })

    return {
        url: contentUrl,
        payloadToSaveApplicantProgress,
        pageType,
    }
}
